// Dependencies
import {Component} from 'react';
import {connect} from 'react-redux';
import {reset, next, pop, startLoading, stopLoading, scrollToTop} from "../../redux/checkoutProcessReducer";
import radium from "radium";
import paymentApi from "../../lib/api/payment"
import history from "../../lib/history";
import Spinner from "../../components/spinner/Spinner";
import {LEO_THEME} from "../../dev";

// Templates
import CHECKOUT_SUCCESS from "./templates/CHECKOUT_SUCCESS";
import PP_OVERVIEW from "./templates/PP_OVERVIEW";
import NO_MATCH from "./templates/NO_MATCH";
import PURCHASE_OVERVIEW from "./templates/PURCHASE_OVERVIEW";
import CHECKOUT_ERROR from "./templates/CHECKOUT_ERROR";
import CHECKOUT_SC_EXPIRED from "./templates/CHECKOUT_SC_EXPIRED";
import PAYPAL_AUTH from "./templates/PAYPAL_AUTH";
import VR_PAY from "./templates/VR_PAY/VR_PAY";
import PP_ERROR from "./templates/PP_ERROR";

const components = {
	PURCHASE_OVERVIEW,
	CHECKOUT_SUCCESS,
	PP_OVERVIEW,
	CHECKOUT_ERROR,
	PAYPAL_AUTH,
	VR_PAY,
	NO_MATCH,
	CHECKOUT_SC_EXPIRED,
	PP_ERROR
}

class CheckoutDispatcherPage extends Component {
	constructor(props) {
		super(props);

		this.style = {
			containerOuter: {
				width: '100%',
				display: 'flex',
				flexDirection: 'column'
			},
			container: {
				margin: 'auto',
				display: 'flex',
				flexWrap: 'wrap',
				alignContent: 'center',
				paddingBottom: '5em',
			},
			error: {
				fontWeight: '600',
				textAlign: 'center',
				width: '100%',
			},
			buttonContainer: {
				marginTop: '3em',
			},
			list: {
				margin: '1em 0 0',
				width: '100%',
			},
		};
	}

	next(params) {
		const paymentState = Object.assign({history: this.props.checkoutHistory}, params)
		this.props.next(paymentState, this.props.mercIds)
	}

	pop(params) {
		const paymentState = Object.assign({history: this.props.checkoutHistory}, params)
		this.props.pop(paymentState, this.props.mercIds)
	}

	reset(params) {
		const paymentState = Object.assign({history: this.props.checkoutHistory}, params)
		this.props.reset(paymentState, this.props.mercIds)
	}

	getButtonLabelsForTemplate(template){
		const themeModule = LEO_THEME.modules[template] || {};
		return {
			nextBtnLabel: themeModule['nextBtnLabel'] || null,
			backBtnLabel: themeModule['backBtnLabel'] || null,
			resetBtnLabel: themeModule['resetBtnLabel'] || null,
		}
	}

	render(){
		if (this.props.checkoutHistory.length < 1) {
			history.push('shoppingcart');
			return
		}

		const compExist = !!components[this.props.component]
		const Component = compExist ? components[this.props.component] : NO_MATCH;
		const btnLabels = this.getButtonLabelsForTemplate(Component.name)

		return (
			<div style={this.style.containerOuter}>
				{this.props.isLoading && <Spinner />}
				<Component
					checkoutProps={this.props.lastHistoryElement}
					btnLabels={btnLabels}
					next={this.next.bind(this)}
					pop={this.pop.bind(this)}
					reset={this.reset.bind(this)}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const event = state.event.elements[state.event.selected] || null;
	const eventUuid = event ? event.uuid : null;
	const lastHistoryElement = state.checkout.checkoutHistory[state.checkout.checkoutHistory.length - 1];
	const component = lastHistoryElement ? lastHistoryElement.name : null;
	const isLoading = state.checkout.isLoading;

	return {
		eventUuid,
		shoppingCartId: state.shoppingCart.elements[state.merchant.merchantId].secureId,
		checkoutHistory: state.checkout.checkoutHistory,
		lastHistoryElement,
		mercIds: state.merchant,
		component,
		isLoading
	};
};

const mapDispatchToProps = (dispatch) => ({
	next:
		async (params, mercIds) => {
		dispatch(startLoading());
		try {
			const checkoutState = await paymentApi.next(params, mercIds)
			dispatch(
				next(checkoutState)
			);
			dispatch(scrollToTop());
		} catch {
			dispatch(stopLoading());
			history.push('checkout-error')
		}

	},
	pop: async (payload, mercIds) => {
		dispatch(startLoading());
		try {
			const response = await paymentApi.pop(payload, mercIds)
			dispatch(
				pop(response.states)
			);
			dispatch(scrollToTop());
		} catch {
			dispatch(stopLoading());
			history.push('checkout-error')
		}
	},
	reset: async (payload, mercIds) => {
		dispatch(startLoading());
		await paymentApi.reset(payload, mercIds)
		dispatch(reset());
		dispatch(scrollToTop());
		dispatch(stopLoading());
	}
});

const RadiumCheckoutProcess = radium(CheckoutDispatcherPage);

export default connect(
	mapStateToProps, mapDispatchToProps
)(RadiumCheckoutProcess);
